import React from "react";
import { IoIosArrowDown } from "react-icons/io";

const InputForm = ({ title, placeholder, titleClassName = "", icon }) => {
  return (
    <div className="px-[19px]">
      <p
        className={`font-pop text-sm font-bold uppercase text-darkGreen ${titleClassName}`}
      >
        {title}
      </p>
      <div className="mb-2 grid grid-cols-5 items-stretch">
        <input
          type="text"
          className="border-[rgba(0, 47, 52, 0.36)] col-span-4 box-border border border-r-transparent py-2.5 px-3.5 font-pop text-xs font-semibold text-black opacity-50 outline-none placeholder:font-pop placeholder:text-xs placeholder:font-semibold placeholder:text-black placeholder:opacity-50"
          placeholder={placeholder || ""}
        />
        <button className="box-border flex grow items-center justify-center border border-l-0 border-darkGreen border-opacity-[.36] bg-primary text-3xl text-white">
          {icon ? icon : <IoIosArrowDown />}
        </button>
      </div>
    </div>
  );
};

export default InputForm;
